export default {
  LEVEL_LIST: 'WebsiteSTNHD/LevelList',
  TEACHER_LIST_BY_LEVEL: 'WebsiteSTNHD/NotificationListByLevel',
  TEACHER_LIST_BY_SEARCH: 'WebsiteSTNHD/NotificationListSearch',
};
